import React, { ReactElement } from 'react'
import stepsHelp from './steps/index'
import HelpStepsComponent from 'app_components/modules/helpSteps/containers/helpStepsComponent'
import {TooltipRenderProps} from 'react-joyride'
import { ITypeTypesHelpSteps } from 'app_types/components/helpSteps/helpStepsTypes'

type ITypesScreensHelpSteps = string

interface HelpStepsCustoms {
  tooltipComponent?: React.ElementType<TooltipRenderProps>
  type?: ITypeTypesHelpSteps
  children?: ReactElement
}
class HelpStepsService {

  constructor() {}

  /**
   * @INFO Renderizar el modulo de ayuda
   * @param screen
   */
  public renderHelpModule = (queryStep: ITypesScreensHelpSteps, customs?: HelpStepsCustoms) => {
    const steps = this.getStepsFromScreen(queryStep)
    if (!steps) return null
    return (
      <HelpStepsComponent
        steps={steps}
        showSkipButton={false}
        tooltipComponent={customs?.tooltipComponent}
        type={customs?.type}
        styleJoyride={{
          options: {
            arrowColor: '#C1C8C8',
            primaryColor: '#7C878E'
          }
        }}
        children={customs?.children}
      />
    )
  }

  /**
   * @INFO Obtener los pasos según la query
   * @param queryStep
   * @returns
   */
  private getStepsFromScreen = (queryStep: ITypesScreensHelpSteps) => {
    // @ts-ignore
    let response: IStepHelpSteps[] | undefined = stepsHelp[queryStep]
    return response
  }

}

export default HelpStepsService
